import React, {createContext, useContext} from 'react';
import invariant from 'tiny-invariant';

interface ContextType {
  serverURL: URL;
}
const EmbeddedContext = createContext<ContextType | undefined>(undefined);

interface EmbeddedProviderProps {
  serverURL: URL;
  children: React.ReactNode;
}

export function EmbeddedProvider({serverURL, children}: EmbeddedProviderProps) {
  invariant(serverURL instanceof URL, 'serverURL should be of type URL');

  return <EmbeddedContext.Provider value={{serverURL}}>{children}</EmbeddedContext.Provider>;
}

export function useServerURL(): URL {
  const context = useContext(EmbeddedContext);

  invariant(context !== undefined, 'useServerURL must be used within EmbeddedProvider');

  return context.serverURL;
}
